module.exports = "data:image/svg+xml;base64,PHN2ZwogIHdpZHRoPSIxMiIKICBoZWlnaHQ9IjEyIgogIHZpZXdCb3g9IjAgMCAxMiAxMiIKICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCj4KICA8dGl0bGU+UGFnZSAxPC90aXRsZT4KICA8cGF0aAogICAgZD0iTTEwLjkwOSAwTDYgNC45MDkgMS4wOS0uMDAxIDAgMS4wOSA0LjkwOSA2IDAgMTAuOTEgMS4wOSAxMiA2IDcuMDkxIDEwLjkxIDEyIDEyIDEwLjkxIDcuMDkxIDZsNC45MS00LjkxeiIKICAgIGZpbGw9IiMwMDAwMDAiCiAgICBmaWxsLXJ1bGU9ImV2ZW5vZGQiCiAgLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-close.svg
// module id = 1477
// module chunks = 168707334958949